import PropTypes from "prop-types"
import { Paper } from "@mui/material"
import Panel from "./panel"
import Positions from "./positions"
import GroupsPanel from "components/compare-groups-panel"
import "./styles.scss"

function CompareCompositionTables({
  data,
  items,
  columns,
  groups,
  selectedGroup,
  setGroup,
  saveGroupToStore,
  positionsDisplayType,
  setPositionsDisplayType,
  positionsSorting,
  setPositionsSorting,
  positionsPagination,
  showPositionsPage,
  openSecurityProfile,
  openCompositeSecurity,
  fixedItemNumber,
  maxNbColumns,
  isActive,
}) {
  return <Paper className="components_compare-composition-tables" square elevation={0}>
    <Panel items={items.summary} columns={columns} data={data} fixedItemNumber={fixedItemNumber} />
    <Panel items={items.beta} columns={columns} data={data} fixedItemNumber={fixedItemNumber} />
    <GroupsPanel
      {...{
        items: items.groups,
        columns,
        data,
        groups,
        selectedGroup,
        setGroup,
        saveGroupToStore,
        fixedItemNumber,
        maxNbColumns,
      }}
    />
    <Positions {...{
      items: items.positions,
      columns,
      data,
      positionsDisplayType,
      setPositionsDisplayType,
      positionsSorting,
      setPositionsSorting,
      positionsPagination,
      showPositionsPage,
      openSecurityProfile,
      openCompositeSecurity,
      fixedItemNumber,
      isActive,
    }}
    />
  </Paper>
}

CompareCompositionTables.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  items: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
  selectedGroup: PropTypes.object.isRequired,
  setGroup: PropTypes.func.isRequired,
  saveGroupToStore: PropTypes.func.isRequired,
  positionsDisplayType: PropTypes.object.isRequired,
  setPositionsDisplayType: PropTypes.func.isRequired,
  positionsSorting: PropTypes.object.isRequired,
  setPositionsSorting: PropTypes.func.isRequired,
  positionsPagination: PropTypes.object.isRequired,
  showPositionsPage: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  fixedItemNumber: PropTypes.bool,
  maxNbColumns: PropTypes.number,
  isActive: PropTypes.bool.isRequired,
}

export default CompareCompositionTables
